import { connect } from 'react-redux';

import { getFlightClass } from 'checkout/store/selectors/view';
import {
  economyFlightsCountSelector,
  businessFlightsCountSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { changeFlightClassAction } from '../../store/flights/slice';

import FlightClassSwitcher from './FlightClassSwitcher';

const mapStateToProps = (state) => ({
  flightClass: getFlightClass(state),
  economyCount: economyFlightsCountSelector(state),
  businessCount: businessFlightsCountSelector(state),
});

const mapDispatchToProps = {
  setFlightClass: changeFlightClassAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlightClassSwitcher);
